import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type Props = {
  hasActiveFilters: boolean;
  onClearFilters: () => void;
  /** フィルタ無しなのに0件（登録案内へ誘導） */
  onRegister?: () => void;
};

/** 検索・フィルタで一覧が空のときの案内 */
export default function TppCardListEmptyFiltered({
  hasActiveFilters,
  onClearFilters,
  onRegister,
}: Props) {
  const { t } = useTranslation();
  return (
    <div className="text-center text-muted py-5 px-3">
      <p className="mb-3">
        {hasActiveFilters ? t('tpp.no_cards_in_list') : t('tpp.no_cards_register_hint')}
      </p>
      {hasActiveFilters ? (
        <Button size="sm" variant="outline-secondary" onClick={onClearFilters}>
          {t('tpp.clear_list_filters')}
        </Button>
      ) : onRegister ? (
        <Button size="sm" variant="primary" onClick={onRegister}>
          {t('tpp.empty_register_cta')}
        </Button>
      ) : null}
    </div>
  );
}
